// eslint-disable-next-line import/prefer-default-export
export const QR_ATTENDANCE_ROUTE = '/offline/qr_attendance';
